<template lang="html">

<div v-if="review != null">
    
    <div class="columns">
        <div class="column" style="width:100%;">
            <div class="content row my-3">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex">
                        <div class="d-flex" style="min-width:340px;">
                            <!-- Rating Section -->
                            <div class="text-primary cta-2 me-2">
                                <div style="width:25px;display:inline-block;text-align:right;margin-right:3px;">{{review.mark}}</div>
                                <small>/ 10</small>
                            </div>

                            <!-- Like/Dislike Button -->
                            <button
                                @mouseenter="hovered = true"
                                @mouseleave="hovered = false"
                                class="btn btn-icon btn-icon-only me-2"
                                :class="hovered ? toggle_thumb_color_class : thumb_color_class"
                                type="button">
                                <div class="is-small text-white"
                                     @click="toggle_thumb">
                                    <i class="icon-12"
                                       :class="hovered ? toggle_thumb_class : thumb_class"></i>
                                </div>
                            </button>


                            <!-- Profile Image and Dropdown -->
                            <a href="#"
                               id="btnGroupDrop_fiche"
                               class="me-2"
                               data-bs-toggle="dropdown"
                               aria-expanded="false" >
                                <img :src="backendUrl + review.platform.logo2"
                                     class="img-fluid rounded-md sh-4"
                                     style="width:32px;"
                                     alt="thumb">
                            </a>
                            <ul class="dropdown-menu p-2 ">
                                <a class="col-10"
                                   v-if="conn_info != null && conn_info.establishment_link != ''"
                                   :href="conn_info.establishment_link"
                                   target="_blank"
                                   style="display:block; text-overflow:ellipsis; overflow:hidden;">
                                    Voir la fiche
                                </a>
                                <a class="col-10"
                                   v-if="review.link_on_platform != '' "
                                   :href="review.link_on_platform"
                                   target="_blank"
                                   style="display:block; text-overflow:ellipsis; overflow:hidden;">
                                    Voir l'avis
                                </a>
                            </ul>
                            <!-- Key Icon and Dropdown -->
                            <button class="btn btn-icon btn-icon-only btn-outline-primary me-2"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                <i class="icon-12 bi-key"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end sw-40 me-2">
                                <div class="px-4 py-3" v-if="conn_info">
                                    <div class="row g-2 mb-2 cursor-pointer" @click="copyInPaperWeight('mail')">
                                        <div class="col-2 text-muted">
                                            <i class="icon-16 bi-person me-2"></i>
                                        </div>
                                        <p
                                           class="col p-0"
                                           ref="mail">{{conn_info.login}}</p>
                                    </div>
                                    <div class="row g-2 mb-2 cursor-pointer" @click="copyInPaperWeight('pass')">
                                        <div class="col-2 text-muted">
                                            <i class="icon-16 bi-key me-2"></i>
                                        </div>
                                        <div class="col p-0" >Mot de Passe</div>
                                        <textarea
                                            class="hide is-pulled-left"
                                            ref="pass">{{conn_info.password}}</textarea>
                                    </div>
                                    <div class="row g-2 mt-2">
                                        {{conn_info.info}}
                                    </div>
                                </div>
                            </ul>


                            <!-- More Button with Badge -->
                            <a href="#"
                               class="btn btn-icon btn-icon-only btn-outline-primary me-2 position-relative"
                               data-bs-toggle="collapse"
                               data-bs-target="#collapseMore"
                               aria-expanded="true"
                               aria-controls="collapseMore">
                                <i class="icon-12 bi-three-dots-vertical"></i>
                                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                    {{details_info_count}}
                                </span>
                            </a>

                            <!-- Language Selector -->
                            <div  v-if="review.native_lang.uid != undefined">
                                <select id="select2Basic"
                                        class="form-select sw-14"
                                        v-model="review.native_lang.uid"
                                        @change="updateLang()">
                                    <option :value="lg.uid"
                                            v-for="lg in langs">{{lg.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="d-flex align-items-right establishment-name-rs"
                             :class="{'show-pad': showPad}">
                            
                            <span class="cta-5 text-primary m-1">
                                {{ review.establishment.name }}
                            </span>
                            
                            <a :href="review.establishment.website"
                               target="_blank"
                               title="Site officiel"
                               class="me-2 ms-auto">
                                <i class="icon-18 bi-globe"></i>
                            </a>
                            <a v-if="review.establishment.page_reseau_public"
                               :href="review.establishment.page_reseau_public"
                               target="_blank"
                               title="Lien reseaux social"
                               class="me-2">
                                <i class="icon-18 bi-facebook"></i>
                            </a>
                            <a v-if="review.establishment.page_reseau_public_2"
                               :href="review.establishment.page_reseau_public_2"
                               target="_blank"
                               title="Lien reseaux social"
                               class="me-2">
                                <i class="icon-18 bi-instagram"></i>
                            </a>
                        </div>
                    </div>
                                            <!-- Right Section: Date Information -->
                    <div class="col-auto ms-auto d-flex align-items-center "
                         style="margin-left: auto;;"
                         v-if="field_labels">
                        <div class="" style="margin-top:-3px;">
                            <div class="col-auto align-items-center"
                                 style="height:17px;margin-bottom:2px;"
                                 v-if="review.published_on"
                                 title="Date de dépôt (Published on)">
                                <i class="icon-14 bi-pencil-square me-2"></i>
                                <span class="align-middle" >
                                    &nbsp;{{to_clean_date3(review.published_on)}}&nbsp;&nbsp;
                                </span>
                            </div>
                            <div class="col-auto align-items-center"
                                 style="height:17px;"
                                 v-if="review.journey_date"
                                 :title="field_labels['journey_date']">
                                <i class="icon-14 bi-calendar3 me-2"></i>
                                <span class="align-middle">
                                    &nbsp;{{review.journey_date}}&nbsp;&nbsp;
                                </span>
                            </div>
                        </div>
                    </div>

                    </div>


                </div>

                <div class="collapse card  mb-3" id="collapseMore">
                    <div class="card-body">
                        <table data-v-602d1d58="" class="table small"><tr data-v-602d1d58="">
                            <td data-v-602d1d58="">Establishment scrap ID</td><td data-v-602d1d58="">{{review.establishment.scrap_id}}</td></tr>
                            <tr data-v-602d1d58=""><td data-v-602d1d58="">Review scrap ID</td><td data-v-602d1d58="">{{review.scrap_id}}</td></tr>
                            <tr v-if="f.value" v-for="f in detail_fields">
                                <td style="width:150px;">{{f.label}}</td>
                                <td>{{f.value}}</td>
                            </tr>
                            </table>
                    </div>

                </div>

                <div class="content">
                    <div class="card mb-2">
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-12  d-flex align-items-center justify-content-between" v-if="field_labels">
                                    <div class="col d-flex flex-wrap">
                                        <span class="me-3" data-bs-toggle="tooltip" data-bs-placement="bottom"  v-if="review.typo_client" :title="field_labels['typo_client']"><i class="icon-14 bi-people me-2"></i><span class="align-middle">&nbsp;{{review.typo_client}}&nbsp;&nbsp;</span></span>
                                        <span class="me-3" data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="review.pays" :title="field_labels['pays']"><i class="icon-14 bi-geo me-1"></i><span class="align-middle">&nbsp;{{review.pays}}&nbsp;&nbsp;</span></span>
                                        <span class="me-3" data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="review.photo" :title="field_labels['photo']"><i class="icon-14 bi-images me-1"></i><span class="align-middle">Présence de photo</span></span>
                                        <span class="me-3" data-bs-toggle="tooltip" data-bs-placement="bottom"  v-if="review.nbr_nuits" :title="field_labels['nbr_nuits']" ><i class="icon-14 bi-moon-stars me-1"></i><span class="align-middle">&nbsp;{{review.nbr_nuits}}&nbsp;&nbsp;</span></span>
                                        <span class="me-3" data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="review.type_heberg" :title="field_labels['type_heberg']"><svg style="width: 16px;"  class="me-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 336l0 64 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 576 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-64 0-96c0-61.9-50.1-112-112-112l-224 0c-26.5 0-48 21.5-48 48l0 144L32 320 32 48zM608 384L32 384l0-32 240 0 336 0 0 32zm0-144l0 80-320 0 0-144c0-8.8 7.2-16 16-16l224 0c44.2 0 80 35.8 80 80zM96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z"/></svg><span class="align-middle">&nbsp;{{review.type_heberg}}&nbsp;&nbsp;</span></span>
                                        <span class="me-3" data-bs-toggle="tooltip" data-bs-placement="bottom" v-if="review.has_answer" :title="field_labels['has_answer']" ><i class="icon-14 bi-chat-text me-1"></i><span class="align-middle">&nbsp;Présence d'une réponse&nbsp;&nbsp;</span></span>
                                    </div>
                                    <div class="col-auto">
                                        <a v-if="review.author_url" :href="review.author_url" target="blank" class="text-primary"><i class="icon-14 bi-person-circle me-2"></i>{{review.author}}</a>
                                        <span v-else="v-else">{{review.author}}</span>
                                    </div>
                                </div>
                            </div>

                            <textarea class="form-control mb-3" style="white-space: pre-wrap;" :disabled="review.native_lang.code=='FR'" placeholder="Titre en français" v-model="review.title_fr" rows="1"></textarea>
                            <div class="mb-2 text-alternate">
                                <textarea class="form-control" rows="5" style="white-space: pre-wrap; resize: both;" :disabled="review.native_lang.code=='FR'" placeholder="Avis en français" v-model="review.text_fr"></textarea>
                            </div>

                            <div class="d-flex align-items-center justify-content-between">
                                <a href="#" class="d-flex align-items-center" data-bs-toggle="collapse"
                                data-bs-target="#collapseEN"
                                aria-expanded="true"
                                aria-controls="collapseEN"
                                @click="show_native = !show_native;"
                                v-if="review.native_lang.code !== 'FR'" >
                                    <MyFlag :lang="review.native_lang.code.toLowerCase()"/>
                                    <span v-if="show_native">Cacher</span>
                                    <span v-else>Voir l'avis original</span>
                                </a>
                                <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                                    <button type="button" class="btn btn-sm btn-primary" @click="save_text()" v-if="review.native_lang.code!=='FR'" >Enregistrer</button>
                                    <div class="btn-group" role="group" v-if="review.native_lang.code !== 'FR'">
                                        <button
                                                id="btnGroupDrop1"
                                                type="button"
                                                class="btn btn-outline-primary btn-sm dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                                >
                                            Traduire
                                        </button>
                                        <div class="dropdown-menu"
                                             aria-labelledby="btnGroupDrop1" >
                                            <a class="dropdown-item"
                                               :href="google_translate_link"
                                               target="_blank"
                                               click="open_trad" >
                                                Via google
                                            </a>
                                            <a class="dropdown-item"
                                               :href="deeple_translate_link"
                                               target="_blank" click="open_trad">
                                                Via deepl
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse" id="collapseEN">
                                <div class="mt-2 mb-3 text-alternate">
                                    <textarea disabled class="form-control" rows="1" v-if="review.native_lang.code !=='FR' &amp;&amp; show_native" placeholder="Texte de l'avis">{{review.title_native|fix_newline}}</textarea>
                                    <textarea disabled class="form-control mt-2" rows="5" v-if="review.native_lang.code !=='FR' &amp;&amp; show_native" placeholder="Texte de l'avis">{{review.text_native|fix_newline}}</textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import REVIEW_UPDATE_POSITIVE from '@/gql/mutations/reviewUpdatePositive.graphql';
import UPDATE_REVIEW_ANSWERER from '@/gql/mutations/updateReviewAnswerer.graphql';
import UPDATE_REVIEW_LANG from '@/gql/mutations/updateReviewLang.graphql';
import UPDATE_REVIEW_TEXT_FR from '@/gql/mutations/updateReviewTextFr.graphql';
import REVIEW_DETAILS from '@/gql/queries/reviewDetails.graphql';
import CONNECTION_FOR from '@/gql/queries/connectionFor.graphql';
import LANGS from '@/gql/queries/langs.graphql';
import FIELDS_LABEL from '@/gql/queries/fieldsLabel.graphql';
import { gqlQuery, gqlMutation } from '@/gqlClient.js';
import CONSULTANT_SET from '@/gql/queries/consultantSet.graphql';
import settings from "@/settings.coffee";
import ConnectionInfo from '@/components/ConnectionInfo.vue';
import DropDown from '@/components/DropDown';
import moment from "moment";
import MyFlag from "@/components/MyFlag.vue";

export default {
  name: "ReviewDetail",
  props: {
    review: Object,
    showPad: Boolean
  },
  components: {
    ConnectionInfo,
    DropDown,
    MyFlag
  },
  data() {
    return {
      backendUrl: settings.backendMediaUrl,
      show_native: false,
      show_conn: false,
      conn_info: null,
      langs: [],
      show_details: false,
      details: {},
      field_labels: null,
      consultants: [],
      hovered: false
    };
  },
  methods: {
    show_more() {
      this.show_details = !this.show_details;
    },
    to_clean_date(date) {
      return moment(date).format("MMMM YYYY");
    },
    to_clean_date2(date) {
      return moment(date).format("LLL");
    },
    to_clean_date3(date) {
      return moment(date).format("LL");
    },
    open_trad() {
      window.open('%2B + aa');
    },
    consultantClicked(arg) {
      gqlMutation(UPDATE_REVIEW_ANSWERER, { uid: this.review.uid, answerer_uid: arg.uid });
    },
    async toggle_thumb() {
      const new_value = !this.review.positive;
      await gqlMutation(REVIEW_UPDATE_POSITIVE, { uid: this.review.uid, positive: new_value });
    },
    reloadDetails() {
      const vm = this;
      gqlQuery(REVIEW_DETAILS, { review_uid: this.review.uid }).then(resp => {
        vm.details = resp.body.data.review_details;
      });
    },
    reloadConnection() {
      const self = this;
      gqlQuery(CONNECTION_FOR, { platform_uid: this.review.platform.uid, establishment_uid: this.review.establishment.uid })
          .then(resp => {
            const conns = resp.body.data.connection_set;
            self.conn_info = conns.length > 0 ? conns[0] : null;
          });
    },
    async updateLang() {
      await gqlMutation(UPDATE_REVIEW_LANG, { review_uid: this.review.uid, lang_uid: this.review.native_lang.uid });
    },
    async save_text() {
      await gqlMutation(UPDATE_REVIEW_TEXT_FR, {
        review_uid: this.review.uid,
        text_fr: this.review.text_fr,
        title_fr: this.review.title_fr
      });
    },
    closeListener(e) {
      const selected = this.$el.querySelector(".show-conn-button");
      if (selected && !selected.contains(e.target)) {
        this.show_conn = false;
      }
    },
    copyInPaperWeight(refName) {
      const el = this.$refs[refName];
      const text = el.tagName.toLowerCase() === 'textarea' ? el.value : el.textContent;

      navigator.clipboard.writeText(text)
          .then(() => {
            this.$store.dispatch("notify", {
              level: "success",
              text: "Copié!",
              seconds: 2
            });
          })
          .catch(err => {
            this.$store.dispatch("notify", {
              level: "error",
              text: "Erreur lors de la copie",
              seconds: 2
            });
          });
    }
  },
  filters: {
    remove_newline(txt) {
      return txt ? txt.replace("\\n", " ") : txt;
    },
    fix_newline(txt) {
      return txt ? txt.replace("\\n", "\n") : txt;
    }
  },
  computed: {
    detail_fields() {
      const ret = [];
      for (let key of Object.keys(this.details)) {
        if (key !== 'platform' && key !== 'scraped_on') {
          let value = this.details[key];
          if (["True", "true", true].includes(value)) value = "Oui";
          else if (["False", "false", false].includes(value)) value = "Non";

          if (value && key.includes('note_')) value += "/10";

          if (this.field_labels) {
            ret.push({
              value,
              label: this.field_labels[key]
            });
          }
        }
      }
      return ret;
    },
    details_info_count() {
      return Object.keys(this.details).reduce((acc, key) => {
        const val = this.details[key];
        if (val !== "" && val != null && key !== 'platform' && key !== "scraped_on") acc++;
        return acc;
      }, 0);
    },
    google_translate_link() {
      if (!this.review.text_native) this.review.text_native = "";
      if (!this.review.title_native) this.review.title_native = "";

      const text = this.review.title_native + "%0A%0A" +
          this.review.text_native
              .replace(/&/g, " ")
              .replace(/\n/g, "%0A")
              .replace(/\+/g, "%2B");

      return `https://translate.google.fr/?sl=auto&tl=fr&op=translate&text=${text}`;
    },
    deeple_translate_link() {
      const textNative = (this.review.text_native || "").replace(/&/g, " ")
          .replace(/\%/g, "%25")
          .replace(/\n/g, "%0A")
          .replace(/\+/g, "+")
          .replace(/\//g, "%E2%88%95");

      const titleNative = (this.review.title_native || "").replace(/&/g, " ")
          .replace(/\%/g, "%25")
          .replace(/\n/g, "%0A")
          .replace(/\+/g, "+")
          .replace(/\//g, "%E2%88%95");

      const text = `${titleNative}%0A%0A${textNative}`;
      return `https://www.deepl.com/translator#${this.review.native_lang.code.toLowerCase()}/fr/${text}`;
    },
    native_lang_code() {
      return this.review.native_lang.code.toLowerCase();
    },
    thumb_color_class() {
      return {
        "bg-success": this.review.positive === true,
        "bg-danger": this.review.positive === false
      };
    },
    thumb_class() {
      return {
        "bi-hand-thumbs-up first": this.review.positive === true,
        "bi-hand-thumbs-down second": this.review.positive === false
      };
    },
    toggle_thumb_color_class() {
      return {
        "bg-success": this.review.positive === false,
        "bg-danger": this.review.positive === true
      };
    },
    toggle_thumb_class() {
      return {
        "bi-hand-thumbs-up first": this.review.positive === false,
        "bi-hand-thumbs-down second": this.review.positive === true
      };
    },
    answerer() {
      return this.review.answerer || { uid: null, fullnale: null };
    }
  },
  watch: {
    "review.uid"(newVal) {
      this.reloadConnection();
      this.reloadDetails();
    }
    // Pour activer si besoin :
    // "review.native_lang.uid"(newV, oldV) {
    //   console.log("review.native_lang.uid", newV, oldV);
    //   this.updateLang();
    // }
  },
  async mounted() {
    const self = this;
    document.addEventListener("click", self.closeListener, true);
    this.reloadConnection();
    this.reloadDetails();

    const [consultantRes, langsRes, labelsRes] = await Promise.all([
      gqlQuery(CONSULTANT_SET, {}),
      gqlQuery(LANGS, {}),
      gqlQuery(FIELDS_LABEL, { model: 'review.review' }),
    ]);
    self.consultants = consultantRes.body.data.consultant_set;
    self.langs = langsRes.body.data.lang_set;
    const field_labels = {};
    for (let f of labelsRes.body.data.fields_label_set) {
      field_labels[f.name] = f.verbose_name;
    }
    self.field_labels = field_labels;
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeListener, true);
  }
};
</script>


<style scoped lang="scss">

.noti-counter{
    border-radius:30px;
    font-size: 10px;
    /*padding:0 5px 0 5px;*/
    position: relative;
    bottom: 10px;
    left: -10px;

}
.hide{
    opacity: 0;
    width:0px;
    height:0px;
}
.establishment-name-rs{
    opacity:1;
    visibility:visible;
    max-height: 30px;
    overflow:hidden;
    max-width: 400px;
    text-wrap:nowrap;
    text-overflow: ellipsis;
    margin-top:5px;
}
.establishment-name-rs.show-pad{
    opacity:0;
    max-width:0px;
}
</style>
